module.exports = __webpack_public_path__ + "img/asiatic-lilly.cf2bc55e.webp";